import capitalize from 'lodash.capitalize';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Importer, TImporterState } from '@feathr/blackbox';
import type { TStatusTheme } from '@feathr/components';
import { inferPillTheme, StatusPillCell } from '@feathr/components';

import type { IImportDetailsToggle } from './ImportDetailsButton';
import ImportDetailsButton from './ImportDetailsButton';
import ImportRunningStatus from './ImportRunningStatus';

interface IProps {
  /** Makes the chip open and close the row's Import details. */
  detailsToggle?: IImportDetailsToggle;
  importer: Importer;
  isRevampEnabled: boolean;
}

export const importerStateThemes: Record<TImporterState, TStatusTheme> = {
  ['draft']: 'neutral',
  ['pending']: 'warning',
  ['processing']: 'info',
  ['complete']: 'success',
  ['failed']: 'error',
};

function ImporterStateChip({
  detailsToggle,
  importer,
  isRevampEnabled,
}: Readonly<IProps>): JSX.Element {
  const state = importer.get('state');

  if (isRevampEnabled && importer.get('is_running')) {
    return <ImportRunningStatus progress={importer.get('progress')} />;
  }

  const status = capitalize(state);
  const chip = (
    <StatusPillCell
      status={status}
      theme={inferPillTheme(state, importerStateThemes)}
      truncate={false}
    />
  );

  return detailsToggle ? (
    <ImportDetailsButton {...detailsToggle} label={status}>
      {chip}
    </ImportDetailsButton>
  ) : (
    chip
  );
}

export default observer(ImporterStateChip);
